<div class="document-upload__container" [ngClass]="{ disabled: disabled }">
  <p
    class="t-bold"
    [ngClass]="{ 't-alt': disabled }"
    data-test-id="fileUploadDragDropLabel"
  >
    @if (config?.icons && !hasFile) {
      <i class="icon icon--medium" data-test-id="documentUploadWarningIcon">
        {{ config?.icons?.warning }}
      </i>
    }
    @if (config?.icons && hasFile) {
      <i class="icon icon--medium" data-test-id="documentUploadSuccessIcon">
        {{ config?.icons?.success }}
      </i>
    }
    {{ config?.dragLabel || 'Drag and drop files or' }}
  </p>
  <ng-content></ng-content>
</div>
